import { Post } from '@/payload-types'
import { placeholderImageUri } from '@/utilities/placeholder'
import { type ImageProps } from 'next/image'
import { ImageWithFallback } from './ImageWithFallback'
import { VideoWithFallback } from './VideoWithFallback'

export interface MediaProps {
    media?: Post['heroImage']
    options?: Partial<ImageProps & { autoPlay: boolean; useHoverImageOverlay: boolean }>
}

export const MediaWithFallback: React.FC<MediaProps> = ({ media, options = {} as ImageProps }) => {
    // If this is video, render a video player
    let imageSource: string | undefined | null
    let type: 'image' | 'video' = 'image'
    if (typeof media === 'object') {
        // Use thumbnail url if it is available (For video), otherwise just use the media url
        imageSource = media?.url
        if (media?.mimeType?.includes('video')) {
            // Use the thumbnail image, or else
            // Load in the video
            if (media?.thumbnailURL) {
                imageSource = media.thumbnailURL
            } else {
                type = 'video'
            }
        }
    } else if (typeof media === 'string') {
        // Check if url is valid
        if (media.startsWith('/') || media.startsWith('http')) {
            imageSource = media
            if (media.includes('mp4')) {
                type = 'video'
            }
        } else {
            imageSource = placeholderImageUri
        }
    }

    if (type === 'image') {
        return <ImageWithFallback {...options} src={options.src || imageSource || ''} alt={options.alt || ''} />
    } else {
        return <VideoWithFallback media={media} options={options} />
    }
}
